import React, { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";

/** Text input with a dropdown of matching existing records. onPick(item) fires when a suggestion is chosen. */
export function Typeahead({ value, onChange, onPick, items, getLabel, getSub, placeholder, testId, emptyHint }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const q = (value || "").trim().toLowerCase();
  const matches = q ? items.filter((i) => getLabel(i).toLowerCase().includes(q) || (getSub?.(i) || "").toLowerCase().includes(q)).slice(0, 8) : items.slice(0, 8);
  const exact = items.find((i) => getLabel(i).toLowerCase() === q);
  return (
    <div className="relative" ref={ref}>
      <Input value={value} placeholder={placeholder} data-testid={testId} autoComplete="off"
        onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onKeyDown={(e) => { if (e.key === "Escape" || e.key === "Tab") setOpen(false); }} />
      {open && matches.length > 0 && (
        <div className="absolute z-50 mt-1 w-full rounded-md border border-slate-200 bg-white shadow-lg max-h-60 overflow-auto text-sm" data-testid={`${testId}-menu`}>
          {matches.map((i, idx) => (
            <button type="button" key={idx} data-testid={`${testId}-option-${idx}`}
              className="w-full text-left px-3 py-2 hover:bg-[#eef5fc] border-b border-slate-100 last:border-0"
              onMouseDown={(e) => { e.preventDefault(); onPick(i); setOpen(false); }}>
              <div className="font-medium text-slate-900">{getLabel(i)}</div>
              {getSub && <div className="text-xs text-slate-500">{getSub(i)}</div>}
            </button>
          ))}
        </div>
      )}
      {q && !exact && emptyHint && <div className="mt-1 text-[11px] text-emerald-700" data-testid={`${testId}-new-hint`}>{emptyHint.replace("{q}", value.trim())}</div>}
    </div>
  );
}
